import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiServiceService } from '../../modules/services/api-service.service';
import alertify from 'alertifyjs';
import { HttpErrorResponse } from '@angular/common/http';
import { MdaSettingsModal } from "../../components/mda-settings-modal/mda-settings-modal.component";
import { MdaDetailsItem, MdaDetailsResponse } from '../../modules/shared/models/mda.details';
import { GenericPaginationResponseV2, GenericResponse } from '../../modules/shared/models/general.modal';
import { SettingsService } from '../../modules/services/settings/settings.service';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../../modules/services/authentication.service';

@Component({
  selector: 'app-lga-settings-landing',
  standalone: true,
  templateUrl: './lga-settings-landing.component.html',
  styleUrl: './lga-settings-landing.component.scss',
  imports: [MdaSettingsModal]
})
export class LgaSettingsLandingComponent implements OnInit, OnDestroy{
  mdaDetailsItemList: MdaDetailsItem[];
  isLoadingMdaDetails: boolean = false;
  showModal: boolean = false;
  selectedMdaDetailsItem: MdaDetailsItem;

  // settingsSubscription: Subscription;

  readonly pageSize = 10;
  currentPage = 1;
  totalPages = 1;
  totalItems = 0;
  hasNextPage = false;
  hasPreviousPage = false;

  constructor(
    private readonly apiService: ApiServiceService,
    private readonly settingsService: SettingsService,
    private readonly authService: AuthenticationService
  ) {}

  get isSuperAdmin() {
    return this.authService.hasAnyRoles(["ADMIN"]);
  }

  ngOnInit(): void {
    this.fetchSettings();
    // this.settingsSubscription = this.settingsService.mdaDetails.subscribe({
    //   next: (data: MdaDetailsResponse) => {
    //     if (!data) return;
    //     this.mdaDetailsItemList = Array.of(this.mapMdaDetailsResponseToMdaDetailsItem(data));
    //   }
    // })
  }

  ngOnDestroy(): void {
    // this.settingsSubscription.unsubscribe();
  }

  fetchSettings(page = 1) {
    this.isLoadingMdaDetails = true;

    if (this.isSuperAdmin) {
      const payload = {
        page,
        size: 10
      };
      this.apiService.post('/mda/details/search', payload)
      .subscribe({
        next: (response: GenericPaginationResponseV2<MdaDetailsResponse>) => {
          if (response.status !== "success") {
            alertify.error(response.message || "Failed to fetch MDA details");
          } else {
            if (response.data.content) {
              const mdaDetailsList = response.data.content;
              this.totalItems = response.data.total ?? this.mdaDetailsItemList.length;
              this.totalPages = (Math.ceil(response.data.total / this.pageSize)) ?? 1;
              this.currentPage = response.data.page;
              this.hasNextPage = response.data.page < this.totalPages;
              this.hasPreviousPage = this.currentPage > 1;
              this.mdaDetailsItemList = mdaDetailsList?.map(details => this.mapMdaDetailsResponseToMdaDetailsItem(details)) ?? [];
            }
          }

          this.isLoadingMdaDetails = false;
        },
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            alertify.error(error.message || "An error occured while fetching MDA settings");
          } else {
            alertify.error(error || "An error occured while fetching MDA settings");
          }
          this.isLoadingMdaDetails = false;
        }
      })
    } else {
      this.apiService.get('/mda/details')
      .subscribe({
        next: (response: GenericResponse<MdaDetailsResponse>) => {
          if (response.status !== "success") {
            alertify.error(response.message || "Failed to fetch MDA details");
          } else {
            if (response.data) {
              const mdaDetails = response.data;
              this.mdaDetailsItemList = Array.of(this.mapMdaDetailsResponseToMdaDetailsItem(mdaDetails));
            }
          }
          this.isLoadingMdaDetails = false;
        },
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            alertify.error(error.message || "An error occured while fetching MDA settings");
          } else {
            console.log(error);
            alertify.error(error || "An error occured while fetching MDA settings");
          }
          this.isLoadingMdaDetails = false;
        }
      })
    }
  }

  mapMdaDetailsResponseToMdaDetailsItem(response: MdaDetailsResponse): MdaDetailsItem {
    return {
      mdaId: response.mdaId,
      name: response.mdaName,
      code: response.acronym,
      logo: response.logo,
      headSignature: response.headSignature,
      primaryColor: response.primaryColor,
      secondaryColor: response.secondaryColor
    }
  }

  handleModalClose() {
    this.showModal = false;
    this.selectedMdaDetailsItem = null;
    this.fetchSettings();
  }

  onEdit(mdaDetailsItem: MdaDetailsItem) {
    this.showModal = true;
    this.selectedMdaDetailsItem = mdaDetailsItem;
  }

  goToPreviousPage(): void {
    if (!this.hasPreviousPage || this.isLoadingMdaDetails) return;
    this.fetchSettings(this.currentPage - 1);
  }

  goToNextPage(): void {
    if (!this.hasNextPage || this.isLoadingMdaDetails) return;
    this.fetchSettings(this.currentPage + 1);
  }
}
